/*******************************************************************************
 * @memberof  menu
 * @ngdoc     directive
 * @name      booksController
 *
 * Takes the menuID from the query string key mID and calls a service to verify
 * access. If the access is granted, content is loaded to the DOM and `$scope`
 * is modified to include the menu option application flags as `$appFlags` (and
 * `appFlags` for legacy use). If a controller is provided, it is instantied and
 * injected with `$scope`, `$element`, and `$appFlags`.
 *
 * If the menu option is not authorized, the page will be redirected to the
 * welcome page.
 *
 * TODO: There must be a better way to do this, probably on the server, passing
 * TODO: `appFlags` in the `SERVER` constant.
 *******************************************************************************/
/* @ngInject */ export function BooksControllerDirective($controller, SERVER, BooksSvc, BusyScreen, MenuService, Session) {
  var welcomePage = Session.getSessionURL(
    SERVER.BooksWebConstants.URL_WELCOME
  );

  function link(scope, element, attr, controller, transclude) {
    /*---------------------------------------*/
    /* Attempt to get the menuID. If not     */
    /* available then go to the welcome page */
    /*---------------------------------------*/
    var menuID = MenuService.getAppMenuID();

    if (!menuID) window.location.href = welcomePage;

    /*--------------------------*/
    /* Verify access to the app */
    /*--------------------------*/
    BusyScreen.setBusy(true);
    BooksSvc.checkMenuOption(menuID).then(
      function (r) {
        if (r.data.authorized) {
          /*----------------------------------------*/
          /* Update app flags with menu item flags. */
          /*----------------------------------------*/
          if (Array.isArray(r.data.appFlags))
            r.data.appFlags.forEach(function (f) {
              SERVER.appFlags[f] = true;
            });

          /*-------------------------*/
          /* Add content to the DOM. */
          /*-------------------------*/
          transclude(function (cloneContent, transcludeScope) {
            element.append(cloneContent);

            /*-----------------------------------------*/
            /* Instantiate the controller if provided. */
            /*-----------------------------------------*/
            if (attr.booksController)
              $controller(attr.booksController, {
                $scope: transcludeScope,
                $element: element,
                $appFlags: SERVER.appFlags
              });

            scope.$on('$destroy', function () {
              transcludeScope.$destroy();
            });
          });
        } else window.location.href = welcomePage;
      },
      function () {
        BusyScreen.setBusy(false);
      }
    );
  }

  return {
    restrict: 'A',
    transclude: true,
    link: link
  };
}
